<template>
	<header class="page_title">
		<hgroup :class="[logoImg?'index_title':'child_page_title']">
			<i v-if="showGoBack" @click="goBack()" class="iconfont icon-iconfontzhizuobiaozhun19"></i>
			<h1 v-if="logoImg">
				<img src="../../assets/logo.png" alt="候机楼logo" width="124" height="124"/>
			</h1>
			<h3>{{titleText}}</h3>
		</hgroup>
	</header>
</template>

<script>
export default {
	name:"page-header",
  props:{
    logoImg:{
      type:Boolean,
      required:false,
    },
    titleText: {
      type:String,
      required:true,
    },
    showGoBack:{
      type:Boolean,
      required:false,
    }
  },
	data() {
	  return {

	  }
	},
  methods:{
    goBack(){
    	this.$router.go(-1);
    },
  }
}
</script>

<style scoped lang="less">

	@import "../../style/variable.less";

	.page_title{
		background-color: @primaryColor;
		color: @primaryTextColor;
		.flex_items(0,0,auto,stretch);
		.index_title{
			.flex_wrap(flex-start,center,nowrap,row);
			h1{
				.flex_items(1rem,0,0,stretch);
				margin: 0 3% 0 2%;
			}
			img{
				width: 100%;
				height: 100%;
				border-radius: 50%;
			}
		}
    .child_page_title{
      .flex_wrap(center,center,nowrap,row);
      position: relative;
      &>.iconfont{
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%) rotateY(180deg);
        font-size: .5rem;
        text-align: center;
        width: 1rem;
        line-height: 1rem;
      }
      h3{
        line-height: 1rem;
      }
    }
    .index_title,.child_page_title{
      .border-T();.border-B();.headerPadding();
      h3{
        font-size: .4rem;
        font-weight: 600;
        letter-spacing: 2px;
        text-indent: 2px;
      }
    }
	}

</style>



// WEBPACK FOOTER //
// src/components/child-components/Header.vue